<!--suppress ALL -->

<template>
	<router-link
		class="tr"
		:to="{ name: 'play-page', params: { id: game.id } }"
		target="_blank"
		@click.native.stop="beforeRouter"
	>
		<td class="pa-2">
			{{ game.name }}
		</td>
		<td>
			<span v-if="game.company">{{ game.company.name }}</span>
			<span v-else>זהות מרכזים</span>
		</td>
		<td>
			{{ game.type && game.type.name ? game.type.name : "" }}
		</td>
		<td>
			<div v-if="game.tags && game.tags.length > 0">
				<v-chip
					v-for="tag in game.tags"
					:key="tag.id"
					label
					small
					class="ml-1 mb-1"
				>
					<span class="pr-2">{{ tag.name }}</span>
				</v-chip>
			</div>
		</td>
		<td>
			<div>
				<span v-if="canEdit">
					<edit-btn
						class="mx-2 my-1"
						@click="onEdit"
					/>
					<remove-btn
						class="mx-2 my-1"
						:title="deleteTitle"
						@remove="doRemove"
					/></span>
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							v-if="game.share"
							fab
							small
							v-bind="attrs"
							link
							class="mr-2"
							v-on="on"
							@click.prevent.stop="openShareDialog"
						>
							<v-icon> share </v-icon>
						</v-btn>
					</template>
					<span>שיתוף</span>
				</v-tooltip>
				<v-tooltip top>
					<template #activator="{ on, attrs }">
						<v-btn
							fab
							small
							v-bind="attrs"
							v-on="on"
							@click.prevent.stop="duplicateGame(game)"
						>
							<v-icon> mdi-content-copy </v-icon>
						</v-btn>
					</template>
					<span>שכפול</span>
				</v-tooltip>
			</div>
		</td>
	</router-link>
</template>

<script>
import { types } from "src/store/modules/Game.module";
import RemoveBtn from "src/scaffoldings/RemoveBtn";
import EditBtn from "src/scaffoldings/EditBtn";
import RowMixin from "src/mixins/RowMixin";

export default {
	name: "GameRow",
	components: { EditBtn, RemoveBtn },
	props: {
		game: { required: true },
	},
	mixins: [new RowMixin(types, "game")],
	data () {
		return {};
	},
	computed: {
		auth () {
			return this.$store.state.AuthModule.user;
		},
		isManager () {
			return this.$store.getters.isManager;
		},
		canEdit () {
			return this.isManager || this.game.company_id == this.auth.company_id;
		},
		deleteTitle () {
			return "האם למחוק את המשחק: " + this.game.name + "?";
		},
	},
	methods: {
		openShareDialog () {
			this.$emit("share", this.game);
		},
		editQuestions () {
			this.beforeRouter();
		},
		doRemove () {
			this.$store.dispatch(types.REMOVE, this.game);
		},
		onEdit () {
			this.$emit("edit", this.game);
		},
		beforeRouter () {
			this.$store.commit(types.GET, this.game);
		},
		duplicateGame (game) {
			console.log(game);
			this.$emit("duplicate", game);
		},
	},
};
</script>

<style>
.tr {
  display: table-row;
  color: inherit; /* blue colors for links too */
  text-decoration: inherit; /* no underline */
}
</style>
